if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      // this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      // this.cartDrawer = document.querySelector('cart-drawer');
      //add a listener to the submitButtons
      const submitButtons = [
        ...this.querySelectorAll('[type="submit"]'),
        ...document.querySelectorAll(`[form=${this.form.getAttribute('id')}][type="submit"]`),
      ];
      submitButtons.forEach((button) => {
        button.addEventListener('click', this.onClickSubmitButton.bind(this));
      });
    }

    highlightOptions() {
      //find all data-no-variant and add a border-red class
      const noVariantElements = document.querySelectorAll('[data-no-variant]');
      noVariantElements.forEach((element) => {
        element.classList.add('border-red-shade-1');
      });

      //select all variant-error-message and add the 'flex' class
      const variantErrorMessage = document.querySelectorAll('.variant-error-message');
      variantErrorMessage.forEach((element) => {
        element.classList.add('flex');
        element.classList.remove('hidden');
      });

      //scrollTo the first noVariantElement
      noVariantElements[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
    onClickSubmitButton(evt) {
      evt.preventDefault();
      const submitButton = evt.target.closest('[type="submit"]');
      if (submitButton.classList.contains('show-prompt')) {
        this.highlightOptions();
      } else {
        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('button--loading');
        this.onSubmitHandler(evt, submitButton);
      }
    }
    onSubmitHandler(evt, submitButton) {
      evt.preventDefault();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = [
        // ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
        ...this.cartNotification.getSectionsToRender().map((section) => section.id),
      ];

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status == 422) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('button--loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
